// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Login from "./components/user/Login";

// Client view components
//import ClientListView from "./components/ClientListView";
import DashboardOverview from "./components/DashboardOverview";
import GoalListView from "./components/GoalListView";
import IssueListView from "./components/IssueListView";
import ActionItemListView from "./components/ActionItemListView";
import SentimentListView from "./components/SentimentListView";
import KnowledgeGraphView from "./components/KnowledgeGraphView";
import InsightsView from "./components/InsightsView";
import EntityDetailPage from "./components/EntityDetailPage";

// Staff view components
import StaffListView from "./components/StaffListView";
import StaffView from "./components/StaffView";
import StaffOverview from "./components/StaffOverview";

// Internal/Department View Components
import DepartmentListView from "./components/DepartmentListView";
import DepartmentOverview from "./components/DepartmentOverview";
import InternalOverviewView from "./components/InternalOverviewView";
import InternalGoalListView from "./components/InternalGoalListView";
import InternalActionItemListView from "./components/InternalActionItemListView";
import InternalSentimentView from "./components/InternalSentimentView";
import InternalIssueListView from "./components/InternalIssueListView"; // <-- IMPORTED
import { isAdminUser } from "./utils";

const NotFound = () => (
  <div className="text-center p-10">
    <h2 className="text-xl font-semibold mb-6">404 - Not Found</h2>
    <p className="text-gray-500">The page you requested does not exist.</p>
  </div>
);

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />



        <Route path="/staff" element={<Dashboard />}>
          <Route index element={<StaffOverview />} />
          <Route path="list" element={<StaffListView />} />
          <Route path=":staffId" element={<StaffView />} />
          <Route path="*" element={<Navigate to="/staff" replace />} />
        </Route>

        <Route path="/internal" element={<Dashboard />}>
          <Route index element={<DepartmentOverview />} />
          <Route path="list" element={<DepartmentListView />} />
          {/* Flattened Department View: single tab, multi-department filter in header */}
          <Route path="goals/:entityId" element={<EntityDetailPage entityType="goals" />} />
          <Route path="initiatives/:entityId" element={<EntityDetailPage entityType="initiatives" />} />
          <Route path="issues/:entityId" element={<EntityDetailPage entityType="issues" />} />
          <Route path="action-items/:entityId" element={<EntityDetailPage entityType="action-items" />} />
          <Route path="*" element={<Navigate to="/internal" replace />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
